import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            borderLeft: 'none',
            padding: remCalc(24),
            position: 'relative',
            alignItems: 'center',
            background: 'background.success',
        },
        icon: {
            color: 'text.success',
        },
        title: {
            textStyle: 'body-small',
            color: 'text.success',
            ml: remCalc(16),
        },
        description: {
            fontSize: 'sm',
        },
        closeButton: {
            height: remCalc(24),
        },
    },
    variants: {
        success: {
            container: {
                background: 'background.success',
            },
            icon: {
                color: 'text.success',
            },
            title: {
                color: 'text.success',
            },
        },
        error: {
            container: {
                background: 'background.danger',
            },
            icon: {
                color: 'text.danger',
            },
            title: {
                color: 'text.danger',
            },
        },
    },
}
